// Import redux/toolkit
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/AuthSlice";
import businessReducer from "./slices/BusinessSlice";
import appReducer from "./slices/AppSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    business: businessReducer,
    app: appReducer,
  },
});

export default store;
